import { flushNativePersistence, restoreNativePersistence } from '~/utils/nativePersistence'
import { ACCOUNT_DELETION_SESSION } from '~/utils/accountDeletion'
import { onAppStateChange } from '~/composables/useAppLifecycle'

export default defineNuxtPlugin({
  name: 'native-persistence',
  enforce: 'pre',
  // A confirmed remote deletion must clear its recovery receipt first.
  dependsOn: ['account-deleted'],
  async setup() {
    if (ACCOUNT_DELETION_SESSION) return
    await restoreNativePersistence()
    // 📱 M6: the mirror flushes on pagehide and a hidden page; the app's own
    // trip to the background (useAppLifecycle) is one more chance to retry a
    // failed write before Android kills the process.
    onAppStateChange((active) => {
      if (!active) flushNativePersistence().catch(error => console.warn('Native save mirror flush failed.', error))
    })
  },
})
